import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import { fetch, TopRankRsp, RankItem } from '@/fetch.ts';
import KingItem from '@hooks/act/tab3/kingItem.tsx';
const { useEffect, useState, useContext } = React;
interface TabsType {
  current: number,
  title: string,
  time: string,
}
interface Props {
  index: number,
}
const Tab3: React.FC<Props> = props => {
  const [tabs] = useState<TabsType[]>([
    {
      current: 0,
      title: '五大国民偶像',
      time: '10.18-10.26',
    },
    // {
    //   current: 1,
    //   title: '最强交友天团',
    //   time: '10.18-10.26',
    // },
    {
      current: 1,
      title: '五大电竞明星',
      time: '10.23-10.31',
    },
  ])
  const [list, List] = useState<RankItem[]>([]);
  const { iGameStage, iEntStage, tabToastOpen } = useContext(StageDefault);
  const [current, Current] = useState<number>((iEntStage > 4 && iGameStage > 0) ? 2 : 1);
  const [banner, Banner] = useState<string>('');
  useEffect(() => {
    fetch.StarGetTopRank(
      {
        iAreaId: [2, 1][current - 1],
      }
    )
      .then((rsp: TopRankRsp) => {
        // console.log('五大', [2, 1][current - 1], JSON.stringify(rsp));
        List(rsp.tPanel.vRankList.value);
        Banner(rsp.sDesc);
      })
  }, [current])
  return (
    <div className='tab3'>
      <div className='tab3_nav'>
        {
          [tabs].map((item: any, index: number) => (
            <ul key={index}>
              {
                item.map((navItem: TabsType, Index: number) => (
                  <li
                    key={Index}
                    className={
                      current === (Index + 1) ? 'on' : ''
                    }
                    onClick={
                      () => {
                        if (iGameStage <= 0 && (Index + 1) === 2) {
                          tabToastOpen('该赛程暂未开始，敬请期待');
                          return;
                        };
                        Current(Index + 1);
                      }
                    }
                  >
                    <h2>{navItem.title}</h2>
                    <i></i>
                    <p>{navItem.time}</p>
                  </li>
                ))
              }
            </ul>
          ))
        }
      </div>
      <div className='tab3_banner'>{banner}</div>
      <div className='starlist'>
        {
          list.map((ITEM: RankItem) => (
            <KingItem key={ITEM.tJump.lPid} {...ITEM} current={current}/>
          ))
        }
      </div>
    </div>
  )
}

export default Tab3;